// Where success messages appear, on every page (routes/__root.tsx). shadcn's sonner block is
// not used as generated: its theme line does not pass exactOptionalPropertyTypes, and files in
// components/ui are never edited (CLAUDE.md, rule 6). So sonner's own Toaster is mounted here
// with exactly the props that block passes — the popover palette, lucide's icons, the
// cn-toast class — and the app's theme, which is the class on <html> (lib/theme.ts).
// Features call sonner's toast.success(); nothing here is a feature's.
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import type { CSSProperties } from "react";
import { Toaster as Sonner } from "sonner";
import { useCurrentTheme } from "@/lib/theme";

const ICONS = {
  success: <CircleCheckIcon className="size-4" />,
  info: <InfoIcon className="size-4" />,
  warning: <TriangleAlertIcon className="size-4" />,
  error: <OctagonXIcon className="size-4" />,
  loading: <Loader2Icon className="size-4 animate-spin" />,
};

const PALETTE = {
  "--normal-bg": "var(--popover)",
  "--normal-text": "var(--popover-foreground)",
  "--normal-border": "var(--border)",
  "--border-radius": "var(--radius)",
} as CSSProperties;

export function Toaster() {
  const theme = useCurrentTheme();
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      // Sonner's own colours per type: success green, error red. The one place the UI steps
      // outside the shadcn palette, chosen so a success reads as one at a glance.
      richColors
      className="toaster group"
      icons={ICONS}
      style={PALETTE}
      toastOptions={{ classNames: { toast: "cn-toast" } }}
    />
  );
}
